<div class="login-container">
  <mat-card class="login-card">
    <div class="login-header">
      <div class="login-icon-wrapper">
        <mat-icon>lock</mat-icon>
      </div>
      <h2 class="login-title">Willkommen zurück!</h2>
      <p class="login-subtitle">Melden Sie sich an, um fortzufahren</p>
    </div>

    <div class="login-form">
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>E-Mail</mat-label>
          <mat-icon matPrefix>email</mat-icon>
          <input matInput type="email" formControlName="email" placeholder="ihre@email.com">
          <mat-error *ngIf="loginForm.get('email')?.hasError('required')">
            E-Mail ist erforderlich
          </mat-error>
          <mat-error *ngIf="loginForm.get('email')?.hasError('email')">
            Ungültige E-Mail-Adresse
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Passwort</mat-label>
          <mat-icon matPrefix>lock</mat-icon>
          <input matInput [type]="hide ? 'password' : 'text'" formControlName="password" placeholder="Ihr Passwort">
          <button mat-icon-button matSuffix (click)="hide = !hide" type="button" tabindex="-1">
            <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          <mat-error *ngIf="loginForm.get('password')?.hasError('required')">
            Passwort ist erforderlich
          </mat-error>
        </mat-form-field>

        <div class="login-actions">
          <button mat-raised-button color="primary" class="login-submit-btn" type="submit"
                  [disabled]="!loginForm.valid || isLoading">
            <mat-icon *ngIf="!isLoading">login</mat-icon>
            <mat-spinner *ngIf="isLoading" diameter="20" style="display:inline-block;margin-right:8px"></mat-spinner>
            {{ isLoading ? 'Wird angemeldet...' : 'Anmelden' }}
          </button>
          <div class="login-forgot">
            <a routerLink="/password-reset">Passwort vergessen?</a>
          </div>
        </div>
      </form>

      <p *ngIf="error" class="error-message">{{ error }}</p>
    </div>
  </mat-card>
</div>
